// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { validationTaskStatuses } from '../statuses';
import { getFileCategory } from '../../../config/fileConfig';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class AccountingValidationTasksPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingValidationTasks';
        this.Server =
            this.props.context.getState().server.accountingValidationTasks;
        this.MenuDisplayType = 'menu';
        // this.searchFields = ['gatewayAccount.name', 'systemAccount.name'];
        this.showDatePicker = false;
        this.disableGlobalEditor = true;

        const defaultHead = [
            {
                id: 'dateFrom',
                label: 'dateFrom',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'dateTo',
                label: 'dateTo',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'uuidColumnIndex',
                label: 'uuidColumnIndex',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,

            },
            {
                id: 'amountColumnIndex',
                label: 'amountColumnIndex',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
            },
            {
                id: 'statusColumnIndex',
                label: 'statusColumnIndex',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
            },
            {
                id: 'processedStatuses',
                label: 'processedStatuses',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
            },
            {
                id: 'stateDesc',
                label: 'stateDesc',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,

            },

            {
                id: 'gatewayAccountId',
                label: 'gatewayAccount',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'accountingGatewayAccounts',
                object: 'gatewayAccount',
                displayGrid: true,
                helperText: 'chooseEitherGatewayOrMerchant',
                showIfDialog: (data) => !data?.merchantTerminalId,
            },
            {
                id: 'merchantTerminalId',
                label: 'merchantTerminal',
                alignRight: false,
                cell: 'Select',
                show: 'name+merchantTerminalUuid',
                from: 'publicMerchantTerminals',
                object: 'merchantTerminal',
                displayGrid: true,
                helperText: 'chooseEitherGatewayOrMerchant',
                showIfDialog: (data) => !data?.gatewayAccountId,
            },
            {
                id: 'taskStatus',
                label: 'taskStatus',
                alignRight: false,
                cell: 'State',
                items: Object.keys(validationTaskStatuses),
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'dataDiff',
                label: 'dataDiff',
                alignRight: false,
                cell: 'Diff',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'csvFileId',
                label: 'csvFile',
                alignRight: false,
                cell: 'Upload',
                object: 'csvFile',
                fileCategory: getFileCategory('diff'),
                displayGrid: true
            },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
